// extracted by mini-css-extract-plugin
module.exports = {"icon":"Checkbox_icon__3VOaM","iconEmpty":"Checkbox_iconEmpty__1DJoM","iconChecked":"Checkbox_iconChecked__395ae","iconInvisible":"Checkbox_iconInvisible__Rgaxk"};